import script from "./searchResult.vue?vue&type=script&setup=true&lang=js"
export * from "./searchResult.vue?vue&type=script&setup=true&lang=js"

import "./searchResult.vue?vue&type=style&index=0&id=5a8393f8&scoped=true&lang=css"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a8393f8"]])

export default __exports__